import { render } from "./biometricConfiguration.vue?vue&type=template&id=a72c2e36&scoped=true"
import script from "./biometricConfiguration.vue?vue&type=script&lang=js"
export * from "./biometricConfiguration.vue?vue&type=script&lang=js"

import "./biometric-configuration.scss?vue&type=style&index=0&id=a72c2e36&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72c2e36"]])

export default __exports__